import styled from 'styled-components'

export const TopbarContainer = styled.div`
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  z-index: 1001;
`

export const TopbarMain = styled.div`
  padding: 0 1.35rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
`

export const TopbarNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #d8d8d8;
`

export const TopbarTitle = styled.h1`
  font-weight: 500;
  min-width: 330px;
  font-size: 1rem;
  color: ${(props) => props.theme.colors.text};
  line-height: 1.1rem;
`

export const Pill = styled.div<{ bg?: string }>`
  padding: 0.2em 0.3em;
  color: #fff;
  background: ${props => props.bg ? props.bg : 'orange'};
  display: inline-block;
  border-radius: 0.3em;
  font-size: 12px;
`
